import { render, staticRenderFns } from "./panel_checkInfo.vue?vue&type=template&id=45cafaa8&scoped=true&"
import script from "./panel_checkInfo.vue?vue&type=script&lang=js&"
export * from "./panel_checkInfo.vue?vue&type=script&lang=js&"
import style0 from "./panel_checkInfo.vue?vue&type=style&index=0&id=45cafaa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cafaa8",
  null
  
)

export default component.exports